<h5 *ngIf="anfrageTitel" class="anfragetitle">{{ anfrageTitel }}</h5>
<div #clickDummy></div>
<div class="freigeben-dialog-wrapper" [ngClass]="{'single-column-grid': isSingleColumn}">
  <div class="freigeben-dialog-wrapper-left">
    <div>
      <kendo-textbox #searchEmailTextBoxRef type="text" [formControl]="searchControlEmail" placeholder="{{'freigebendialog.email' | translate }}" (keydown)="onSearchEmailKeyDown($event)">
      </kendo-textbox>
      <div class="listview-wrapper">
        <kendo-listview [data]="searchResultEmail" containerClass="k-d-flex k-flex-col k-flex-nowrap" *ngIf="searchResultEmail.length > 0">
          <ng-template
            kendoListViewItemTemplate
            let-dataItem="dataItem"
            let-isFirst="isFirst">
            <app-avatar class="contact" [avatar]="dataItem" [new]="true" (addFunction)="addAvatar(dataItem, false)" [subtext]="subtext"></app-avatar>
          </ng-template>
        </kendo-listview>
      </div>
    </div>
  
    <div *ngIf="isVorschlaegeVisible" class="user-listview">
      <kendo-listview [kendoListViewBinding]="usersOfInstitution" containerClass="k-d-flex k-flex-col k-flex-nowrap" [pageable]="pagerSettings" [pageSize]="pageSize">
        <ng-template kendoListViewHeaderTemplate>
          <div class="header" translate>freigebendialog.vorschlaege</div>
        </ng-template>
        <ng-template
          kendoListViewItemTemplate
          let-dataItem="dataItem"
          let-isFirst="isFirst">
          <app-avatar class="contact" [avatar]="dataItem" [new]="true" (addFunction)="addAvatar(dataItem, true)" [vorschlagsliste]="true"></app-avatar>
        </ng-template>
      </kendo-listview>
    </div>
  
    <div class="active-listview" *ngIf="showLiveUsers">
      <kendo-listview [kendoListViewBinding]="livePortalzugriffe" containerClass="k-d-flex k-flex-col k-flex-nowrap"  [pageable]="pagerSettings" [pageSize]="pageSize">
        <ng-template kendoListViewHeaderTemplate>
          <div class="header" translate><span class="k-icon k-i-kpi-status-open" style="padding-bottom: 0.15rem; margin-right: 0.5rem"></span>freigebendialog.aktuell</div>
        </ng-template>
        <ng-template
          kendoListViewItemTemplate
          let-dataItem="dataItem"
          let-isFirst="isFirst">
          <app-avatar class="contact" [avatar]="dataItem" [new]="false"></app-avatar>
        </ng-template>
      </kendo-listview>
    </div>
  </div>
  <div class="freigeben-dialog-wrapper-right">
    <kendo-listview [kendoListViewBinding]="portalzugriffe" containerClass="k-d-flex k-flex-col k-flex-nowrap"  [pageable]="pagerSettings" [pageSize]="dynamicPageSize" [skip]="dynamicSkip">
      <ng-template kendoListViewHeaderTemplate>
        <div class="header" translate>freigebendialog.hinzugefuegt</div>
      </ng-template>
      <ng-template
        kendoListViewItemTemplate
        let-dataItem="dataItem"
        let-isFirst="isFirst">
        <app-avatar class="contact" [avatar]="dataItem" [new]="false" (removeFunction)="removeAvatar(dataItem)"></app-avatar>
      </ng-template>
    </kendo-listview>
  </div>
</div>
<kendo-dialog-actions>
    <button kendoButton class="cancel-button" (click)="onCancelClick()" translate>
        <i></i>&nbsp;
        {{cancelText}}
    </button>
    <button [disabled]="!isListDirty" kendoButton class="confirm-button" (click)="onConformClick()" translate>
        <i></i>&nbsp;
        {{confirmText}}
    </button>
</kendo-dialog-actions>